import {
  CreateRequestingOrganisationDto,
  RequestingOrganisationService,
} from '@services/RequestingOrganisationsService'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Actions } from '@state/actions'
import { enqueueSnackbar } from '@state/reducers/alertReducer'

export const findAllOrganisations = createAsyncThunk(
  Actions.ORGANISATION_FIND_ALL,
  async (
    params: {
      siteId?: number
      search?: string
      page?: number
      limit?: number
    } = {},
    { rejectWithValue },
  ) => {
    try {
      return await RequestingOrganisationService.findAll(params)
    } catch (e: any) {
      return rejectWithValue(e?.response?.data?.message)
    }
  },
)

export const createOrganisation = createAsyncThunk(
  Actions.ORGANISATION_CREATE,
  async (
    body: CreateRequestingOrganisationDto,
    { rejectWithValue, dispatch },
  ) => {
    try {
      const result = await RequestingOrganisationService.create({ body })
      dispatch(
        enqueueSnackbar({
          message: 'Organisation créée avec succès',
          type: 'success',
        }),
      )
      return result
    } catch (e: any) {
      return rejectWithValue(e?.response?.data?.message)
    }
  },
)

export const updateOrganisation = createAsyncThunk(
  Actions.ORGANISATION_UPDATE,
  async (
    {
      id,
      body,
    }: { id: string; body: Partial<CreateRequestingOrganisationDto> },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const result = await RequestingOrganisationService.update({ id, body })
      dispatch(
        enqueueSnackbar({
          message: 'Organisation mise à jour avec succès',
          type: 'success',
        }),
      )
      return result
    } catch (e: any) {
      return rejectWithValue(e?.response?.data?.message)
    }
  },
)

export const removeOrganisation = createAsyncThunk(
  Actions.ORGANISATION_REMOVE,
  async ({ ids }: { ids: string[] }, { rejectWithValue, dispatch }) => {
    try {
      await RequestingOrganisationService.remove({ ids })
      dispatch(
        enqueueSnackbar({
          message: 'Organisation(s) supprimée(s) avec succès',
          type: 'success',
        }),
      )
      return { ids }
    } catch (e: any) {
      return rejectWithValue(e?.response?.data?.message)
    }
  },
)
